import * as React from "react";
import * as ReactDOM from "react-dom";
import classnames from "classnames";
import Loader from "../components/loader";
import css from "./dialog.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
const dialogId = "msem-widget-dialog";
const getContainer = () => {
  let container = document.getElementById(dialogId);
  if (!container) {
    container = document.createElement("div");
    container.id = dialogId;
    document.body.appendChild(container);
  }
  return container;
};
const Dialog = ({
  scrollableRef,
  opened,
  children,
  maxWidth,
  grounded,
  close
}) => {
  const container = getContainer();
  const backdropRef = React.useRef();
  const backdropClasses = classnames(css.backdrop, {
    [css.opened]: opened,
    [css.grounded]: grounded
  });
  const dialogClasses = classnames(css.dialog, {
    [css.opened]: opened,
    [css.grounded]: grounded
  });
  const backdropClicked = e => {
    if (e.target === backdropRef.current) {
      close();
    }
  };
  const keyPressed = e => {
    if (e.keyCode === 27) {
      close();
    }
  };
  return ReactDOM.createPortal(_jsx("div", {
    ref: backdropRef,
    className: backdropClasses,
    onClick: backdropClicked,
    onKeyUp: keyPressed,
    children: _jsx("div", {
      className: dialogClasses,
      style: {
        maxWidth
      },
      children: _jsx("div", {
        ref: scrollableRef,
        className: css.scrollable,
        children: _jsx(React.Suspense, {
          fallback: _jsx(Loader, {}),
          children: children
        })
      })
    })
  }), container);
};
export default Dialog;